import routerBluepay from './router/bluepay/index.js'
import routerJtwallet from './router/jtwallet/index.js'
import store from './store'
import { storage } from '@/utils/storage-times.js'
// import ConstData from '@/constants/ConstData'
// const dsBridge = require('dsbridge')
import getPageTitle from '@/utils/get-page-title'

// 路由跳转白名单，值为路由name
const whitePageList = [
  'BluePay',
  'Login',
  'Register',
  'ResetPassword',
  'Activate',
  'PrivacyAgreement',
  'TermsOfService',
  'ServicePolicy',
  'TheSpecialRules',
  'Protocol',
  'ProtocolTh',
  'newProtocol'
]
let router

if (process.env.VUE_APP_PLATFORM === 'bluepay') {
  router = routerBluepay
}
if (process.env.VUE_APP_PLATFORM === 'jtwallet') {
  router = routerJtwallet
}
router.beforeEach(async (to, from, next) => {
  // set page title
  document.title = getPageTitle(to.meta.title)

  // next()
  const hasToken = storage.get('TOKEN')
  // if (!hasToken) {
  //   hasToken = dsBridge.call('jsapi.get4Sp', ConstData.STORAGE.TOKEN)
  //   storage.set(ConstData.STORAGE.TOKEN, hasToken)
  // }
  // 切换页面保留滚动条高度
  if (from.meta.keepScroll) {
    const $content = document.querySelector(from.meta.scrollContainer)
    const scrollTop = $content ? $content.scrollTop : 0
    from.meta.scrollTop = scrollTop
  }

  if (hasToken) {
    if (process.env.VUE_APP_PLATFORM === 'jtwallet' && whitePageList.includes(to.name)) {
      next()
      return
    }
    if (!store.state.user.userInfo.phone) {
      store
        .dispatch('user/getInfo')
        .then(res => {
          const { reactivate } = res || {}
          sessionStorage.setItem('reactivate', reactivate)

          next()
        })
        .catch(err => {
          // 处理获取用户信息失败的情况
          console.error('Failed to get user info:', err)
          next()
        })
      return // 关键修复：在异步操作后立即 return,防止继续执行
    } else {
      if (to.path === '/login') {
        next('/')
      } else {
        next()
      }
    }
    return
  } else {
    if (whitePageList.includes(to.name)) {
      next()
    } else {
      if (process.env.VUE_APP_PLATFORM === 'jtwallet') {
        next({
          path: '/login?log_status=1',
          query: { redirect: encodeURIComponent(to.fullPath) },
          replace: true // 关键参数，表示替换当前历史记录
        })
        return
      }
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    }
  }
})
